<template>
    <div class="communication">
        <!-- 聊天框 -->
        <div class="chat">
            <div class="chatList">
                <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
                    <el-tab-pane label="全部" name="2"></el-tab-pane>
                    <el-tab-pane label="未读" name="0"></el-tab-pane>
                    <el-tab-pane label="已读" name="1"></el-tab-pane>
                </el-tabs>
                <div class="chat_search">
                    <div class="chat_search_box">
                        <el-input
                            placeholder="姓名/房间号"
                            v-model="searchFrom.userName"
                            prefix-icon="el-icon-search"
                            @input="nameInput"
                        >
                        </el-input>
                    </div>
                    <div class="chat_search_cascader">
                        <div class="chat_search_cascader_left">
                            <!--                searchFrom.source-->
                            <el-select v-model="searchFrom.topicType" @change="sourceChange"
                                       placeholder="请选择消息来源">
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <!--            <div class="chat_search_cascader_right">
                                      <el-select v-model="value" placeholder="请选择">
                                        <el-option
                                          v-for="item in options"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value"
                                        >
                                        </el-option>
                                      </el-select>
                                    </div>-->
                    </div>
                </div>
                <div class="chat_message"  v-loading="loadingChartList"  element-loading-text="拼命加载中"
                     element-loading-spinner="el-icon-loading" @scroll="scrollEvent">
                    <div
                        class="chat_messageList"
                        v-for="(item, index) in messageList"
                        :key="index"
                        @click="goChat(item)"
                    >
                        <div class="chat_messageList_top">
                            <div class="unread" v-if="item.num !== 0">{{ item.num }}</div>
                            <div class="userImg">
                                <!--                  <img v-if="!item.headPortrait" src="../../image/youjia.png" />
                                                <img v-else :src="item.headPortrait" />-->
                                <img v-if="item.topicType==1" src="../../image/youjia.png"/>
                                <img v-if="item.topicType==2" src="../../image/mt.png"/>
                                <img v-if="item.topicType==3" src="../../image/pig.png"/>
                                <img v-if="item.topicType==4" src="../../image/tj.png"/>
<!--                                <div v-if="item.topicType==1">悠家</div>-->
<!--                                <div v-if="item.topicType==2">美团</div>-->
<!--                                <div v-if="item.topicType==3">小猪</div>-->
<!--                                <div v-if="item.topicType==4">途家</div>-->
                            </div>
<!--                            <div class="userName">{{ item.userName }}</div>-->
                            <div class="messageTime">{{ item.latestCreationTime }}</div>
                        </div>
                        <div class="chat_messageList_center">
                            {{ item.latestPayload }}
                        </div>
                        <div class="chat_messageList_bottom" style="display: flex;justify-content: space-between;">
                            <div class="channel">
                                <img v-if="item.topicType==1" src="../../image/youjia.png"/>
                                <img v-if="item.topicType==2" src="../../image/mt.png"/>
                                <img v-if="item.topicType==3" src="../../image/pig.png"/>
                                <img v-if="item.topicType==4" src="../../image/tj.png"/>
                            </div>
                            <div style="margin-right: 20px">房间号:{{ item.houseId }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="chatBox">
                <div class="chatBox_title">
                    <div class="chatBox_title_text">{{ Usertitle }}</div>
                    <div class="houseInfo" v-if="this.houseMessage != null">
                        <div class="houseInfoImg">
                            <img :src="houseMessage.vBedroom" alt=""/>
                        </div>
                        <div class="houseTitle">
                            {{ houseMessage.vHousTitle }}
                        </div>
<!--                        <div class="checkInTime">{{ startTime }} 至 {{ endTime }}</div>-->
                        <div class="configuration">
                            {{ houseMessage.roomNumber }} 室 {{ houseMessage.hallNumber }} 厅
                            {{ houseMessage.kitchenNumber }} 厨
                            {{ houseMessage.bathroomnumber }} 卫 丨可住
                            {{ houseMessage.iLiveNum }} 人 | 房东:{{
                                houseMessage.customerName
                            }}
                            | 管家:{{ houseMessage.cHouSteward }}
                        </div>
                    </div>
                </div>
                <div class="channel_message_box" id="channel_message_box">
                    <div
                        class="channel_message_list"
                        v-for="(item, index) in Oldmessage"
                        :key="index"
                    >
                        <div class="channel_message_left" v-if="item.flag == 1">
                            <div class="channel_message_left_time">
                                {{ myDateFormat(item.creationTime) }}
                            </div>
                            <div class="message_left_userImg">

                                <img v-if="from.type==1" src="../../image/youjia.png"/>
                                <img v-if="from.type==2" src="../../image/mt.png"/>
                                <img v-if="from.type==3" src="../../image/pig.png"/>
                                <img v-if="from.type==4" src="../../image/tj.png"/>
                            </div>
                            <div class="message_left">
                                <span> {{ item.payload }}</span>
                                <!--                  <div class="cardMsg">
                                                      <img style="width: 100%;" src="https://img.meituan.net/phoenix/8073216f9bc09c25da9cfd0ab92d8b0e2060771.jpg"/>
                                                      <div class="house-tit">
                                                          房源标题房源标题房源标题房源标题
                                                      </div>
                                                      <div class="house-desc">
                                                          云南/昆明整套3室·3床·6人
                                                      </div>
                                                      <div class="house-price">
                                                          <span class="comp">￥</span>
                                                          <span class="price">399</span>
                                                          <span class="comp-gary">/晚</span>
                                                      </div>
                                                  </div>-->
                            </div>
                        </div>
                        <div class="channel_message_right" v-if="item.flag == 0">
                            <div class="channel_message_right_time">
                                {{ item.name }} {{ myDateFormat(item.creationTime) }}
                            </div>
                            <div class="message_right_userImg">
                                <img src="../../image/youjia.png"/>
                            </div>
                            <div class="message_right">
                                {{ item.payload }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="channel_return_message">
                    <el-input
                        resize="none"
                        type="textarea"
                        placeholder="请输入内容"
                        v-model.trim="from.payload"
                        maxlength="200"
                    >
                    </el-input>
                    <div class="return_message_btn">
                        <el-button  type="success" class="message_btn" @click="messagebtn"
                        >发送
                        </el-button
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mqtt from "mqtt";
import {MQTT_MQTTIP, MQTT_USERNAME, MQTT_PASSWORD} from "../../utils/MQtt";
import {
    getHouse,
    getChatLogListPC,
    getChatLogPC,
    sendToMqttPC,
    countNumPC, pigSendMsg, merchantmsg, sendMTMsg
} from "../../api/index";
import {format} from '@/utils/util'
import {mapGetters} from 'vuex'
function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(32).substring(1);
}

let MathRandom =
    S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
let MqttUserId = "clientid-" + MathRandom;

var client;
const options = {
    connectTimeout: 40000, //在收到 CONNACK 之前等待的时间
    clientId: MqttUserId,
    username: MQTT_USERNAME,
    password: MQTT_PASSWORD,
    clean: true, //设置为 false 以在离线时接收 QoS 1 和 2 消息
    reconnectPeriod: "1000", //重连时间
    keepalive: 60
};
client = mqtt.connect(MQTT_MQTTIP, options);

export default {
    name: "communication",
    computed:{
        fn1:()=>{
            return this.$store.state.message.msgContent;
        }
    },
    data() {
        return {
            startTime: "",
            endTime: "",
            houseMessage: null,
            countNum: false,
            OldmessageStatus: false,
            topicType: 0,//当前聊天的消息来源
            ChatLog: false,
            // timeStatus: null,
            status: "2",
            topic: "",
            messageList: [], //聊天列表
            value: "",
            searchFrom: {
                userName: null,//姓名房间号
                //nameOrRoomNumOrderNum:'',//姓名，房间号，订单号
                topicType: '', //消息来源
                currentPage:1,
                pageSize:5
            },
            options: [
                {
                    value: "",
                    label: "全部"
                },
                {
                    value: "1",
                    label: "悠家"
                },
                {
                    value: "2",
                    label: "美团"
                },
                {
                    value: "3",
                    label: "小猪"
                },
                {
                    value: "4",
                    label: "途家"
                }/*,
        {
            value: "5",
            label: "爱彼迎"
        }*/

            ],
            inputFlag: null,
            Usertitle: "",
            communication_value: "",
            textarea: "",
            activeName: "2",
            mtopics: "topic/+",
            mtopic: "",
            msg: "",
            client: {},
            Oldmessage: [], //历史数据
            from: {
                // houseId:'',
                payload: "",
                qos: "1",
                receiveUserId: "",
                sendUserId: "",
                topic: "",
                type: ""
            },
            houseId: '',
            pigMsgData: {
                avatar: '',
                content: "",
                fromUserId: 0,
                id: "",
                msgType: "chat", //chat:聊天消息 recommend：推荐房源
                nickname: sessionStorage.getItem('userName'),
                platform: "open",
                roomId: 0,
                timestamp: 0,
                toUserId: 0,
                topic: '',
                houseId: '',
                landlordId: ''
            },
            enterTask:null,
            loadingChartList:false,
            loadingChartLogList:false,
            isNextPage:false,
            pages:0,
        };
    },

    mounted() {
        this.pigMsgData.avatar = this.$store.state.user_info.avatar
        this.pigMsgData.fromUserId = this.$store.state.user_info.userId
        this.pigMsgData.id = this.$store.state.user_info.userId
        console.log(this.pigMsgData)
    },
    created() {
        window.addEventListener('keydown',this.handkeyCode,true)
        this.getChatLogListPCAjax();
        /*this.myMqtts();
        this.myMqtt();*/
        this.$nextTick(() => {
            var channel_message_box = document.getElementById("channel_message_box");
            if (channel_message_box == null) return;
            channel_message_box.scrollTop = channel_message_box.scrollHeight;
        });
    },
    beforeCreate() {
        // console.log(this.houseMessage == null);
    },
    // beforeDestroy() {
    //   this.unsubscribe();
    //   this.unconnect();
    // },
    watch: {
        goBottom() {
            this.$nextTick(() => {
                var channel_message_box = document.getElementById(
                    "channel_message_box"
                );
                if (channel_message_box == null) return;
                channel_message_box.scrollTop = channel_message_box.scrollHeight;
            });
        },
        '$store.state.message.msgContent'(value){
            console.log(value)
            this.GetOldmessage();
            this.countNumPCGet();
            this.searchFrom.currentPage = 1;
            this.getChatLogListPCAjax('not');
        },


    },
    methods: {
        handkeyCode(e) {
            console.log(e.keyCode)
           // 打印出按键后的信息
            if(e.keyCode === 13){
              if(this.enterTask){
                  return;
              }
                this.enterTask = setTimeout(()=>{
                    clearTimeout(this.enterTask);
                    this.enterTask = null
                  this.messagebtn();
              },500)

            }
        },
        myDateFormat(str) {
            if (str) {
                return format("{y}-{m}-{d} {h}:{i}:{s}", new Date(str))
            }
            return str;
        },
        scrollEvent(e){
            const {scrollTop, clientHeight, scrollHeight} = e.target
            if ((scrollTop + clientHeight+1) >= scrollHeight){
                //具体的业务逻辑
                console.log('触底');
                //没有下一页则return
               if(this.searchFrom.currentPage<this.pages){
                   this.searchFrom.currentPage++;
                   const loading = this.$loading({
                       lock: true,
                       text: 'Loading',
                       spinner: 'el-icon-loading',
                       background: 'rgba(0, 0, 0, 0.7)'
                   });
                   this.getChatLogListPCAjax('not',true,loading);
               }else{
                   this.$message.warning('没有更多了')
               }
            }else {
                // console.log((scrollTop + clientHeight) , scrollHeight)
            }
        },
        getParams(form) {
            let url = ''
            const keys = Object.keys(form);
            for (let i = 0; i < keys.length; i++) {
                if (!form[keys[i]]) {
                    continue;
                }
                if (url) {
                    url += `&${keys[i]}=${form[keys[i]]}`;
                } else {
                    url += `?${keys[i]}=${form[keys[i]]}`;
                }
            }
            return url;
        },
        // 获取当前消息
        myMqtt() {
            // 连接mqtt
            client.on("connect", function () {
                console.log("连接成功");
                client.subscribe("presence", function (err) {
                    if (!err) {
                        client.publish("presence", "Hello mqtt");
                    }
                });
            });

            // 接收推送消息
            client.on("message", (topic, message) => {
                this.msg = message.toString();
                // let timeStatus = null;
                // let that = this;
                // if (timeStatus != null) {
                //   clearTimeout(timeoutflag);
                // }
                // var timeoutflag = setTimeout(function() {
                //   timeStatus++;
                //   console.log(
                //     "接收推送信息：",
                //     message.toString(),
                //     "主题",
                //     topic,
                //     1111
                //   ); //````````````
                //   that.msg = message.toString();
                //   that.getChatLogListPCAjax();
                //   if (that.from.topic == "") return;
                //   that.GetOldmessage();
                // }, 500);

                console.log("接收推送信息：", message.toString(), "主题", topic, 111); //````````````
                this.msg = message.toString();
                // this.getChatLogListPCAjax('not');
                if (this.from.topic == "") return;
                this.GetOldmessage();
            });
            // 断开发起重连
            client.on("reconnect", error => {
                console.log("正在重连...", error);
            });
            // 链接异常处理
            client.on("error", error => {
                console.log("连接失败...", error);
            });
        },
        // 获取列表消息
        myMqtts() {
            // 连接mqtt
            client.on("connect", e => {
                console.log("连接成功");
                client.subscribe(this.mtopics, err => {
                    if (!err) {
                        console.log("订阅成功:" + this.mtopics);
                    }
                });
            });
            // 接收推送消息
            client.on("message", (mtopics, message) => {
                // let timeStatus = null;
                // let that = this;
                // if (timeStatus != null) {
                //   clearTimeout(timeoutflag);
                // }
                // var timeoutflag = setTimeout(function() {
                //   timeStatus++;
                //   console.log("接收推送信息：", message.toString(), "主题", topic, 222); //````````````
                //   that.msg = message.toString();
                //   that.countNumPCGet();
                //   that.getChatLogListPCAjax();
                // }, 500);

                console.log("接收推送信息：", message.toString(), "主题", mtopics, 222); //````````````
                this.msg = message.toString();

                if(message.toString()!=='Hello mqtt'){
                    this.countNumPCGet();
                    this.searchFrom.currentPage = 1;
                    this.getChatLogListPCAjax('not');
                }

            });
            // 断开发起重连
            client.on("reconnect", error => {
                console.log("正在重连...", error);
            });
            // 链接异常处理
            client.on("error", error => {
                console.log("连接失败...", error);
            });
        },
        // 获取全部消息
        async countNumPCGet() {
            if (this.countNum) return;
            this.countNum = true;
            const {data: res} = await countNumPC();
            if (res.code == 200) {
                this.countNum = false;
            }
            this.$store.commit("getMessage", res.data);
        },
        // 列表点击事件
        async goChat(e) {
            console.log(e);
            const {houseId,fromUserId,toUserId,topic,topicType} = e;
            this.from.receiveUserId =toUserId;
            this.from.sendUserId =fromUserId;
            this.from.type = topicType;
            this.from.topic = topic;
            this.Usertitle = e.userName;
            this.mtopic = topic;
            this.startTime = e.startTime?format('{y}-{m}-{d}',new Date(e.startTime)):''
            this.endTime = e.startTime?format('{y}-{m}-{d}',new Date(e.endTime)):''
            this.houseId = houseId
            this.pigMsgData.toUserId = toUserId;
            this.pigMsgData.avatar = ''
            this.pigMsgData.fromUserId =fromUserId
            this.pigMsgData.topic = topic;
            this.pigMsgData.houseId = houseId
            this.pigMsgData.landlordId = fromUserId;
            let tempStr = topic.replaceAll('topic/topicS', '')
            this.pigMsgData.roomId = tempStr.slice(0, tempStr.lastIndexOf('U'))
            console.log(this.pigMsgData)
            this.getHouseAjax(houseId);
            this.GetOldmessage();

        },
        async getHouseAjax(id) {
            const {data: res} = await getHouse(id);
            this.houseMessage = res.data;
        },
        // 获取历史数据
        async GetOldmessage() {
            if (this.OldmessageStatus) return;
            this.OldmessageStatus = true;
            const {data: res} = await getChatLogPC({topic: this.from.topic});
            if (res.code == 200) {
                this.OldmessageStatus = false;
            }
            this.countNumPCGet();
            /*res.data.forEach(item=>{

                item.isCard=false;
                item.isObj =false;
                item.msgBody={};
                try {
                    //转化失败则消息不是json字符串
                    let obj = JSON.parse(item.payload)
                    let prop = Object.keys(obj)
                    //key包含product则为卡片消息
                    item.isCard = prop.includes('product');
                    for (const pro in prop) {
                        item.msgBody[pro] = obj[pro]
                    }

                }catch (e){
                    item.msgBody['text'] = item.payload;
                }
            })*/
            this.Oldmessage = res.data;
            console.log('Oldmessage', this.Oldmessage)
            this.$nextTick(() => {
                var channel_message_box = document.getElementById(
                    "channel_message_box"
                );
                if (channel_message_box == null) return;
                channel_message_box.scrollTop = channel_message_box.scrollHeight;
            });
        },
        nameInput(data) {
            if (this.inputFlag) {
                clearTimeout(this.inputFlag)
            }
            this.inputFlag = setTimeout(() => {
                this.getChatLogListPCAjax();
                console.log(data)
            }, 200)
        },
        sourceChange() {
            this.getChatLogListPCAjax();
            console.log(this.searchFrom)
        },
        //获取聊天列表
        async getChatLogListPCAjax(flag,isMontage,loading) {
            // if (this.ChatLog) return;

            this.ChatLog = true;
            if(flag!='not'){
                this.messageList = [];
                this.loadingChartList = true;

            }

            let params = this.getParams(this.searchFrom)

            const {data: res} = await getChatLogListPC(this.status, params);
            if (res.code == 200) {
                this.ChatLog = false;
            }

            this.loadingChartList = false;
            /*res.data.forEach(item=>{

                item.isCard=false;
                item.isObj =false;
                item.msgBody={};
                try {
                    //转化失败则消息不是json字符串
                    let obj = JSON.parse(item.payload)
                    let prop = Object.keys(obj)
                    //key包含product则为卡片消息
                    item.isCard = prop.includes('product');
                    for (const pro in prop) {
                        item.msgBody[pro] = obj[pro]
                    }

                }catch (e){
                    item.msgBody['text'] = item.payload;
                }
            })*/
            if(loading){
                loading.close();
            }
            //是否拼接数据
            this.messageList = isMontage?[...this.messageList,...res.data.list]:res.data.list

            this.pages = Math.ceil(res.data.total / this.searchFrom.pageSize)
            // this.isNextPage = res.data.list.length>0;
            console.log('isNextPage',this.isNextPage)

            // this.mtopics = [];
            // res.data.map(item => {
            //   this.mtopics.push(item.topic);
            // });
        },
        //回复
        async messagebtn() {
            if (this.from.payload == "") return;
            // client.publish(this.mtopic, this.from.payload);
            if (this.from.type == 1 || this.from.type == 2) {
                const {data: res} = await sendToMqttPC(this.from);
                if (res.code !== 200)
                    return this.$message({
                        message: res.msg,
                        type: "error"
                    });
                /*this.from['userId'] = this.from.receiveUserId
                sendMTMsg(this.from)*/
            }


            if (this.from.type == 3) {
                this.pigMsgData['timestamp'] = new Date().getTime();
                this.pigMsgData.content = this.from.payload
                const {data: res} = await pigSendMsg(this.pigMsgData);
                if (res.code !== 200)
                    return this.$message({
                        message: res.msg,
                        type: "error"
                    });
            }

            if (this.from.type == 4) {
                console.log({
                    partnerHid: this.houseId,
                    partnerUid: this.houseId,
                    userChatId: this.from.receiveUserId,
                    contentType: 1,
                    message: this.from.payload,
                    houseId: this.houseId,
                    topic: this.from.topic

                })
                merchantmsg({
                    partnerHid: this.houseId,
                    partnerUid: this.houseId,
                    userChatId: this.from.receiveUserId,
                    contentType: 1,
                    message: this.from.payload,
                    houseId: this.houseId,
                    topic: this.from.topic

                })
            }
            this.from.payload = "";
            this.getChatLogListPCAjax();
            this.GetOldmessage();
        },
        // tab切换
        handleClick(tab, event) {
            this.status = tab.name;
            this.searchFrom.currentPage = 1;
            this.getChatLogListPCAjax();
        },
        // handleclick: function() {
        //   this.client.publish(this.mtopic, this.msg);
        // }
        // unsubscribe() {
        //   client.unsubscribe(
        //     // topic, topic Array, topic Array-Onject
        //     // ['one', 'two', 'three'],
        //     this.onTopic,
        //     err => {
        //       console.log(err || "取消订阅成功");
        //       this.showToast("取消订阅成功", 1000, "success");
        //     }
        //   );
        // },
        // unconnect() {
        //   client.end();
        //   client = null;
        //   showToast("成功断开连接", 1000, "success");
        //   console.log("断开连接");
        // }
        beforeDestroy() {
            window.removeEventListener("scroll", this.goBottom);
        },
        //发送小猪消息
        sendPigMsg() {
            pigSendMsg(this.pigMsgData).then(res => {
                if (res.code == 0) {

                }
            })
        }
    }
};
</script>

<style lang="less" scoped>
.communication {
    width: 100%;
    height: 100%;
    padding: 76px 240px;

    .chat {
        display: flex;
        border-radius: 4px;
        width: 100%;
        height: 100%;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);

        .chatList {
            flex: none;
            width: 432px;
            height: 100%;
            border-right: 1px solid #e1e1e1;

            .chat_search {
                padding: 20px;
                padding-top: 0;
                width: 100%;
                height: 107px;
                border-bottom: 1px solid #e1e1e1;

                .chat_search_box {
                    height: 36px;
                    margin-bottom: 15px;
                }

                .chat_search_cascader {
                    height: 36px;
                    width: 100%;

                    .chat_search_cascader_left {
                        float: left;
                        width: 186px;
                        height: 36px;
                    }

                    .chat_search_cascader_right {
                        float: right;
                        width: 186px;
                        height: 36px;
                    }
                }
            }

            .chat_message {
                width: 100%;
                height: calc(100% - 107px - 67px);
                overflow-y: auto;
                overflow-x: hidden;

                .chat_messageList:hover {
                    background: rgba(47, 128, 237, 0.1);
                }

                .chat_messageList {
                    cursor: pointer;
                    width: 432px;
                    height: 114px;
                    padding: 15px 20px;
                    border-bottom: 1px solid #e1e1e1;

                    .chat_messageList_top {
                        position: relative;
                        margin-bottom: 5px;
                        width: 100%;
                        height: 30px;

                        .unread {
                            position: absolute;
                            top: -3px;
                            left: 21px;
                            min-width: 14px;
                            height: 14px;
                            border-radius: 50%;
                            background-color: #eb5757;
                            font-size: 12px;
                            text-align: center;
                            line-height: 14px;
                            color: #ffffff;
                        }

                        .userImg {
                            border-radius: 50%;
                            text-align: center;
                            float: left;
                            height: 50px;
                            width: 50px;
                            margin-right: 10px;

                            img {
                                width: 100%;
                                height: 100%;
                                border-radius: 50%;
                            }
                        }

                        .userName {
                            float: left;
                            line-height: 30px;
                            font-size: 18px;
                            font-weight: 500;
                            color: #000000;
                        }

                        .messageTime {
                            float: right;
                            margin-right: 10px;
                            font-size: 14px;
                            line-height: 30px;
                            color: #999999;
                        }
                    }

                    .chat_messageList_center {
                        margin-bottom: 10px;
                        height: 18px;
                        line-height: 14px;
                        //padding-left: 40px;
                        color: #999;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .chat_messageList_bottom {
                        margin-bottom: 10px;
                        padding-left: 60px;
                        height: 20px;

                        .channel {
                            height: 30px;
                            width: 30px;
                            border-radius: 50%;

                            img {
                                height: 20px;
                                width: 20px;
                                border-radius: 50%;
                            }
                        }
                    }
                }
            }
        }

        .chatBox {
            flex: 1;
            width: 760px;
            height: 100%;

            .chatBox_title {
                height: 96px;
                box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);

                .chatBox_title_text {
                    text-align: center;
                    line-height: 46px;
                    color: #000;
                    font-size: 16px;
                    height: 46px;
                }

                .houseInfo {
                    position: relative;
                    height: 50px;
                    width: 100%;
                    padding: 0 20px 10px;

                    .houseInfoImg {
                        width: 60px;
                        height: 40px;

                        img {
                            width: 60px;
                            height: 40px;
                        }
                    }

                    .houseTitle {
                        width: 40%;
                        position: absolute;
                        left: 90px;
                        top: 0px;
                        font-size: 14px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .checkInTime {
                        font-weight: 700;
                        position: absolute;
                        right: 50px;
                        top: 0px;
                        font-size: 14px;
                    }

                    .configuration {
                        position: absolute;
                        left: 90px;
                        top: 24px;
                        font-size: 12px;
                    }
                }
            }

            .channel_message_box {
                padding: 20px 20px;
                width: 100%;
                overflow-y: auto;
                overflow-x: hidden;
                height: calc(100% - 150px - 96px);

                .channel_message_list {
                    padding: 38px 0;
                    overflow: hidden;
                    width: 100%;
                    min-height: 42px;

                    .channel_message_left {
                        position: relative;

                        .channel_message_left_time {
                            position: absolute;
                            top: -22px;
                            left: 57px;
                            font-size: 12px;
                            color: #999999;
                        }

                        .message_left_userImg {
                            float: left;
                            margin-right: 15px;
                            border-radius: 50%;
                            overflow: hidden;
                            width: 42px;
                            height: 42px;

                            img {
                                width: 42px;
                                height: 42px;
                            }
                        }

                        .message_left {
                            text-align: left;
                            padding: 12px 10px;
                            float: left;
                            max-width: 540px;
                            min-height: 42px;
                            background: #ffffff;
                            border-radius: 6px;
                            border: 1px solid rgba(0, 0, 0, 0.2);
                        }
                    }

                    .channel_message_right {
                        position: relative;

                        .channel_message_right_time {
                            position: absolute;
                            top: -22px;
                            right: 57px;
                            font-size: 12px;
                            color: #999999;
                        }

                        .message_right_userImg {
                            float: right;
                            margin-left: 15px;
                            border-radius: 50%;
                            overflow: hidden;
                            width: 42px;
                            height: 42px;

                            img {
                                width: 42px;
                                height: 42px;
                            }
                        }

                        .message_right {
                            text-align: left;
                            padding: 12px 10px;
                            float: right;
                            max-width: 540px;
                            min-height: 42px;
                            background: #f6b439;
                            border-radius: 6px;
                            color: rgb(0, 0, 0);
                        }
                    }
                }
            }

            .channel_return_message {
                position: relative;
                padding: 15px;
                // padding-top: 0;
                border: 1px solid #e1e1e1;
                border-left: none;
                width: 100%;
                height: 150px;
                background: #f6f6f6;

                /deep/ .el-textarea__inner {
                    height: 85px;
                    width: 100%;
                    background: #f6f6f6;
                    border: none;
                }

                .return_message_btn {
                    position: absolute;
                    bottom: 15px;
                    right: 15px;
                    width: 72px;
                    height: 36px;

                    .message_btn {
                        width: 72px;
                        height: 36px;
                        border: #f6b439;
                        background: rgba(246, 180, 57, 0.6);
                        border-radius: 4px;
                    }

                    .message_btn:hover {
                        background: #f6b439;
                    }
                }
            }
        }
    }
}

/deep/ .el-tabs__item {
    height: 52px;
    line-height: 53px;
}

/deep/ .el-tabs__item:hover {
    color: #f6b439;
}

/deep/ .el-tabs__nav-scroll {
    height: 53px;
}

/deep/ .el-tabs__nav.is-stretch {
    height: 53px;
}

/deep/ .el-tabs__active-bar {
    background-color: #f6b439;
}

/deep/ .el-tabs__item.is-active {
    color: #f6b439;
}
</style>
